@if (this.layoutVM && !this.layoutVM?.isReadOnly) {
  <div [ngClass]="arenaService.rtlEnabled ? 'menuActionRtl' : 'menuAction'">
    <!-- <div id="fab-dismiss" *ngIf="fabTogglerState==='active'" (click)="onToggleFab()"></div> -->
    <div [ngClass]="isStandaloneDataForm ? 'fab-container fab-container-standalone' : 'fab-container'">
      <button mat-fab [ngClass]="arenaService.rtlEnabled ? 'fab-togglerRtl' : 'fab-toggler'" (click)="onToggleFab()">
        <i class="material-icons md1" [@fabToggler]="{ value: fabTogglerState }">reorder</i>
      </button>
      <div [@speedDialStagger]="buttons.length" [dir]="arenaService.rtlEnabled ? 'rtl' : 'ltr'">
        @for (btn of buttons; track btn) {
          @if (!btn.deny && !btn.readOnly) {
            <button
              [ngClass]="btn.disabled ? 'disabled-color-btn' : ''"
              [ngStyle]="{
                marginRight: btn.beginGroup ? '30px' : '10px',
              }"
              mat-mini-fab
              class="fab-secondary"
              color="secondary"
              disabled="{{ btn.disabled }}"
              matTooltip="{{ btn.tooltip }}"
              (click)="btn.onClick(currentDataEntity)"
            >
              <mat-icon class="iconStyle" svgIcon="{{ btn.icon }}"></mat-icon>
            </button>
          }
        }
      </div>
    </div>
  </div>
}
